/** Fixed measure applicability domain columns (9 total). */

export const APPLICABILITY_VALUE_APPLICABLE = 'applicable';
export const APPLICABILITY_VALUE_NOT_APPLICABLE = 'not_applicable';

export const APPLICABILITY_DOMAIN_KEYS = [
    'personal_data_security',
    'instant_messaging_security',
    'cloud_computing_security',
    'crypto_applications_security',
    'critical_infrastructure_security',
    'new_developments_procurement',
    'os_hardening',
    'db_hardening',
    'server_hardening',
];

export const APPLICABILITY_HEADER_GROUPS = [
    {
        id: 'asset_group_domains',
        labelKey: 'table.headerGroups.assetGroupDomains',
        columnKeys: [
            'personal_data_security',
            'instant_messaging_security',
            'cloud_computing_security',
            'crypto_applications_security',
            'critical_infrastructure_security',
            'new_developments_procurement',
        ],
    },
    {
        id: 'app_tech_domains',
        labelKey: 'table.headerGroups.appTechDomains',
        columnKeys: [
            'os_hardening',
            'db_hardening',
            'server_hardening',
        ],
    },
];

export function buildEmptyApplicabilityMap() {
    return Object.fromEntries(
        APPLICABILITY_DOMAIN_KEYS.map((key) => [key, APPLICABILITY_VALUE_NOT_APPLICABLE]),
    );
}

export function normalizeApplicabilityMap(source = {}) {
    const result = buildEmptyApplicabilityMap();
    for (const key of APPLICABILITY_DOMAIN_KEYS) {
        const value = source?.[key];
        if (value === APPLICABILITY_VALUE_APPLICABLE || value === APPLICABILITY_VALUE_NOT_APPLICABLE) {
            result[key] = value;
        }
    }
    return result;
}
